
import CloseSquare from "../../../assets/filled/CloseSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloseSquareIcon({ className, dataTestid = "CloseSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloseSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
